module.exports = __webpack_public_path__ + "img/symphony_691_silver.89a69b6e.jpg";